import React from 'react';
import Footer from '../components/Footer';

const Partnerships = () => {
  const partnerships = [
    {
      name: "Brain Power Wellness",
      image: "/assets/images/logos/Brain Power.png",
      url: "https://www.brainpowerwellness.com/"
    },
    {
      name: "Bronx Children Museum",
      image: "/assets/images/logos/Bronx Children Museum.png",
      url: "https://www.bronxchildrensmuseum.org/about"
    },
    {
      name: "Yankee Stadium",
      image: "/assets/images/logos/Yankee Stadium.png",
      url: "https://www.mlb.com/yankees/ballpark"
    },
    {
      name: "Saint Barnabas Hospital",
      image: "/assets/images/logos/Saint Barnabas Hospital.png",
      url: "https://www.sbhny.org/"
    },
    {
      name: "Generation Ready",
      image: "/assets/images/logos/Generation Ready.jpeg",
      url: "https://generationready.com/"
    },
    {
      name: "Bank Street",
      image: "/assets/images/logos/Bank Street.png",
      url: "https://www.bankstreet.edu/"
    },
    {
      name: "FitKidz",
      image: "/assets/images/logos/FitKidz.webp",
      url: "https://fitsoccerkids.com/"
    },
    {
      name: "NexSav",
      image: "/assets/images/logos/NexSav.png",
      url: "https://www.nexsav.net/"
    },
    {
      name: "Yale RULER",
      image: "/assets/images/logos/Yale RULER.png",
      url: "https://medicine.yale.edu/childstudy/services/community-and-schools-programs/center-for-emotional-intelligence/"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-[#123f1e] text-white pt-32 pb-20">
        <div aria-hidden="true" className="absolute -z-10 inset-0">
          <div className="absolute bottom-0 left-0 w-1/3 h-2/3 bg-[#febc04] rounded-full blur-3xl opacity-[0.12]"></div>
        </div>

        <header className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-[#febc04] font-semibold text-sm uppercase tracking-[0.15em]">Partnerships</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mt-4 leading-[1.15] tracking-tight">
              Community Connections
            </h1>
            <p className="text-lg sm:text-xl text-white/80 mt-6 leading-relaxed font-light">
              Building strong partnerships with community organizations to enrich our students' learning experiences and support families.
            </p>
          </div>
        </header>
      </section>

      {/* Partnerships Grid */}
      <section className="py-24 sm:py-32 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="sr-only">Our Partners</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            {partnerships.map((partner, index) => (
              <a
                key={index}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative aspect-square bg-white rounded-2xl p-6 sm:p-8 flex items-center justify-center border border-gray-200 hover:border-[#febc04] transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#febc04] focus:ring-offset-2"
              >
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-200"
                />
              </a>
            ))}
          </div>

          <div className="mt-12 flex flex-col items-center gap-4 sm:gap-6">
            <a
              href="https://bronxdistrict9.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-6 p-6 sm:p-8 bg-white rounded-2xl border border-gray-200 hover:border-[#febc04] transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#febc04] focus:ring-offset-2"
            >
              <div className="text-left">
                <h3 className="text-lg sm:text-xl font-bold text-[#123f1e]">Bronx District 9</h3>
                <p className="text-sm text-gray-600 mt-0.5">NYC Public Schools District Office</p>
              </div>
            </a>
            <div className="inline-flex items-center gap-6 p-6 sm:p-8 bg-white rounded-2xl border border-gray-200 hover:border-[#febc04] transition-all duration-200 hover:shadow-md">
              <img
                src="https://goldprekd9.com/wp-content/uploads/2023/05/LEAP.webp"
                alt="LEAP NYC"
                className="h-14 sm:h-16 object-contain"
              />
              <div className="text-left">
                <h3 className="text-lg sm:text-xl font-bold text-[#123f1e]">LEAP NYC</h3>
                <p className="text-sm text-gray-600 mt-0.5">Learning Through Expanded Arts</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Benefits Section */}
      <section className="py-24 sm:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#123f1e] mb-6 leading-[1.15] tracking-tight">
              Why Partnerships Matter
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our partnerships bring valuable resources, expertise, and opportunities to our students and families, creating a richer educational experience.
            </p>
          </div>

          <div className="mb-12">
            <img
              src="/assets/images/gallery/District9PreK-186.jpg"
              alt="Community partnerships in action"
              className="w-full max-w-4xl mx-auto h-80 object-cover rounded-3xl shadow-xl"
            />
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
              <div className="w-12 h-12 bg-[#febc04]/10 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-[#123f1e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#123f1e] mb-3">Enhanced Learning</h3>
              <p className="text-gray-600">Access to specialized programs and educational resources that complement our curriculum.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
              <div className="w-12 h-12 bg-[#febc04]/10 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-[#123f1e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#123f1e] mb-3">Community Support</h3>
              <p className="text-gray-600">Strong network of organizations dedicated to supporting our students and families.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
              <div className="w-12 h-12 bg-[#febc04]/10 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-[#123f1e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#123f1e] mb-3">Real-World Experience</h3>
              <p className="text-gray-600">Opportunities for field trips, workshops, and hands-on learning experiences.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Partnerships;
